(function($) {

    $(document).ready(function () {

        if ($('[data-fancybox="gallery"]').length) {
            $('[data-fancybox="gallery"]').fancybox({
                infobar: false,
                buttons: [
                    "close"
                ],
                idleTime: false,
                backFocus: false,
                hash: false,
                btnTpl: {
                    close:
                        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                        '<svg width="52" height="51" viewBox="0 0 52 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3945 12.6943L38.536 37.8358" stroke="white" stroke-width="4"/><path d="M13.3945 37.835L38.536 12.6935" stroke="white" stroke-width="4"/></svg>' +
                        "</button>",

                    // Arrows
                    arrowLeft:
                        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                        '<div><svg width="25" height="40" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.02148 2.38477L21.7495 19.319L2.20356 37.6645" stroke="white" stroke-width="4"/></svg></div>' +
                        "</button>",

                    arrowRight:
                        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                        '<div><svg width="25" height="40" viewBox="0 0 25 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.02148 2.38477L21.7495 19.319L2.20356 37.6645" stroke="white" stroke-width="4"/></svg></div>' +
                        "</button>",
                },
                helpers: {
                    buttons: {},
                    thumbs: {
                        width: 8,
                        height: 8,
                        source: function () {
                            return "";
                        }
                    }
                }
            });
        }
    });

})( jQuery );